import { p as proxyCustomElement, H, h, d as Host } from './p-bfa0dc67.js';
import { l as labelId, d as descriptionId, L as Label } from './p-8097ff18.js';
import { m as messageId, V as Validation } from './p-319941a1.js';
import { c as classNames } from './p-df8c8ec2.js';

const fieldsetCss = ".sr-only{position:absolute;height:1px;width:1px;padding:0;margin:-1px;overflow:hidden;border:0;left:-9999px;text-indent:-5000px;clip:rect(1px, 1px, 1px, 1px);}*,*:before,*:after{box-sizing:border-box}html,body,div,span,object,iframe,figure,h1,h2,h3,h4,h5,h6,p,blockquote,pre,a,code,em,img,small,strike,strong,sub,sup,tt,b,u,i,ol,ul,li,fieldset,form,label,table,caption,tbody,tfoot,thead,tr,th,td,main,canvas,embed,footer,header,nav,section,button,video{margin:0;padding:0;border:0;font-size:100%;font:inherit;vertical-align:baseline;text-rendering:optimizeLegibility;-webkit-font-smoothing:antialiased;text-size-adjust:none}footer,header,nav,section,main{display:block}body{line-height:1.5}ol,ul{list-style:none}blockquote,q{quotes:none}blockquote:before,blockquote:after,q:before,q:after{content:\"\";content:none}table{border-collapse:collapse;border-spacing:0}input{-webkit-appearance:none;appearance:none;border-radius:0}:host(:focus){outline:none !important;border:none !important}.label-wrapper{display:flex;flex-direction:column;gap:4px;height:fit-content;margin-bottom:8px}.label-wrapper .label{color:#414651;font-size:1rem;line-height:1.5;font-family:\"museo-sans\", arial, sans-serif;height:fit-content}.label-wrapper .label.fontStyle--regular{font-weight:500}.label-wrapper .label.fontStyle--bold{font-weight:700}.label-wrapper .required{color:#8c0a08;margin-left:8px}.label-wrapper .label+.label{font-family:\"museo-sans\", arial, sans-serif;color:#717680;font-size:0.75rem;line-height:1.5}.label-wrapper.dark .label{color:whitesmoke}.label-wrapper.dark .required{color:#ec9a98}.label-wrapper.dark .label+.label{color:#e9eaeb}.label-wrapper.noMargin{margin-bottom:0}.validation-message{font-size:1rem;color:#8c0a08;line-height:1.5;font-family:\"museo-sans\", arial, sans-serif;width:100%;height:1.5rem;margin-top:12px;margin-bottom:12px;display:block}.validation-message.dark{color:#ec9a98}.validation-message.noMargin{margin:0}fieldset{border:none;display:flex;flex-direction:column;gap:8px}fieldset .content{display:flex;flex-direction:column;gap:4px}fieldset .content.row{flex-direction:row}";
const BiFieldsetStyle0 = fieldsetCss;

const BiFieldset$1 = /*@__PURE__*/ proxyCustomElement(class BiFieldset extends H {
    constructor() {
        super();
        this.__registerHost();
        this.__attachShadow();
        /** The font style of the label. */
        this.labelFontStyle = 'regular';
        /** Marks the fieldset as required. */
        this.required = false;
        /** Marks the fieldset as disabled. */
        this.disabled = false;
        /**
         * If `true`, the fieldset will indicate an error.
         * @default false
         */
        this.error = false;
        /** Is the component displayed on a dark background. */
        this.dark = false;
        /** Display the contents in a row/horizontal direction. Use with caution, the standard should be vertical direction */
        this.row = false;
    }
    render() {
        return (h(Host, { key: '4d75486b8da497df4f2639e2d0ab067a408eef1d' }, h("fieldset", { key: 'd9758cf295ff50f531a7dd99da267d935e0f3120', disabled: this.disabled, "aria-labelledby": labelId, "aria-describedby": `${descriptionId} ${messageId}`, role: 'group' }, h(Label, { key: '28e31dab942dbbd26633bcdab4d4d717bea3ae57', type: 'legend', dark: this.dark, label: this.label, labelFontStyle: this.labelFontStyle, helptext: this.helptext, required: this.required, disabled: this.disabled, noMargin: true }), h("div", { key: '8dd7c899e938e9eef894a6c928f4fcd3e3b6d163', class: classNames('content', this.row && 'row') }, h("slot", { key: 'c78820eb351a14dd2e48058dffc8f9df0a70a310' })), h(Validation, { key: '0613dcee4618772c5bc21eaf5c4340f5c448b7d6', noMargin: true, visible: this.error, dark: this.dark, message: this.errorMessage }))));
    }
    static get style() { return BiFieldsetStyle0; }
}, [1, "bi-fieldset", {
        "label": [1],
        "labelFontStyle": [1, "label-font-style"],
        "required": [4],
        "disabled": [4],
        "helptext": [1],
        "errorMessage": [1, "error-message"],
        "error": [4],
        "dark": [4],
        "row": [4]
    }]);
function defineCustomElement$1() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["bi-fieldset"];
    components.forEach(tagName => { switch (tagName) {
        case "bi-fieldset":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, BiFieldset$1);
            }
            break;
    } });
}

const BiFieldset = BiFieldset$1;
const defineCustomElement = defineCustomElement$1;

export { BiFieldset, defineCustomElement };
